<template>
  <div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <el-form-item
        v-for="(item, index) in formItem"
        :label="item.label"
        :key="index"
      >
        <el-select
          style="width:100%"
          v-if="item.options"
          :placeholder="'请选择' + item.label"
          v-model="formParams[item.model]"
        >
          <el-option
            v-for="(o, o_index) in item.options"
            :key="o_index"
            :label="o.label"
            :value="o.model"
          ></el-option>
        </el-select>
        <x-Treeselect
          style="width:100%"
          :defaultExpandLevel="Infinity"
          :placeholder="'请选择' + item.label"
          v-else-if="item.model == 'deptId' || item.model == 'useDeptId'"
          v-model="formParams[item.model]"
          :clearable="true"
          :multiple="false"
          :options="deptArr"
          value="id"
          label="cName"
          id="id"
        ></x-Treeselect>
        <x-Treeselect
          style="width:100%"
          :load-options="loadOptions"
          :placeholder="'请选择' + item.label"
          v-else-if="item.model == 'assetClassify'"
          v-model="formParams[item.model]"
          :clearable="true"
          :multiple="false"
          :options="classifyArr"
          value="id"
          label="cName"
          id="id"
        ></x-Treeselect>
        <el-input
          v-model="formParams[item.model]"
          v-else
          placeholder="请输入资产编号"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog_bottom" style="padding:0px 0px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >导 出</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formParams: { assetStatus: null, maxCount: 0 },
      classifyArr: [],
      deptArr: [],
      formItem: [
        {
          label: "资产状态",
          model: "assetStatus",
          options: [
            {
              label: "不限",
              model: null,
            },
            {
              label: "闲置",
              model: "idle",
            },
            {
              label: "在用",
              model: "use",
            },
            {
              label: "借用",
              model: "borrow",
            },
            {
              label: "维修中",
              model: "repair",
            },
            {
              label: "已处置",
              model: "dispose",
            },
            {
              label: "审批中",
              model: "examine",
            },
          ],
        },
        {
          label: "资产分类",
          model: "assetClassify",
        },
        {
          label: "所属组织",
          model: "deptId",
        },
        {
          label: "使用组织",
          model: "useDeptId",
        },
        {
          label: "资产编号",
          model: "assetCode",
        },
        {
          label: "导出条数",
          model: "maxCount",
          options: [
            {
              label: "不限",
              model: 0,
            },
            {
              label: 100,
              model: 100,
            },
            {
              label: 500,
              model: 500,
            },
            {
              label: 1000,
              model: 1000,
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$downloadAFile(
        {
          url: "/pc/finance/excl/explor",
          data: this.formParams,
        },
        `${this.$getCurrentDate()}资产信息导出`
      );
    },
    /* 递归处理空的children */
    treelabelFulter(arr, label) {
      arr.forEach((item) => {
        item.label = item[label];
        if (item.children == [] || item.children == "") {
          delete item.children;
        }
        if (item.children && item.children.length) {
          this.treelabelFulter(item.children, label);
        }
      });
    },
    loadOptions({ action, parentNode, callback }) {
      console.log(action, parentNode, callback);
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: parentNode.id },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          parentNode.children = result;
          callback();
        }
      );
    },
    /* 资产分类page */
    getClassifyArr() {
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: "0" },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          this.classifyArr = result;
        }
      );
    },
    init() {
      this.getClassifyArr();
      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.treelabelFulter(data.data, "deptName");
          this.deptArr = data.data;
        }
      );
    },
  },
};
</script>
<style scoped></style>
